"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilePicker;
var _react = _interopRequireWildcard(require("react"));
var _reactDropzone = require("react-dropzone");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const dropzoneStyle = {
  borderWidth: 2,
  borderColor: 'black',
  borderStyle: 'dashed',
  borderRadius: 4,
  margin: 30,
  padding: 30,
  width: 200,
  transition: 'all 0.5s'
};
const dropzoneActiveStyle = {
  borderStyle: 'solid',
  borderColor: '#4FC47F'
};
const dropzoneRejectStyle = {
  borderStyle: 'solid',
  borderColor: '#DD3A0A'
};
// multiple={false} onDrop={onFile}
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Either drag and drop a file here, or click here to open a file chooser.");
function FilePicker({
  onFile
}) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragReject
  } = (0, _reactDropzone.useDropzone)({
    accept: 'image/*',
    multiple: false,
    onDrop: onFile
  });
  const style = (0, _react.useMemo)(() => ({
    ...dropzoneStyle,
    ...(isDragActive ? dropzoneActiveStyle : {}),
    ...(isDragReject ? dropzoneRejectStyle : {})
  }), [isDragActive, isDragReject]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", getRootProps({
    style
  }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), _ref));
}